import { render, staticRenderFns } from "./AdminCompaniesTable.vue?vue&type=template&id=396e50c7"
import script from "./AdminCompaniesTable.vue?vue&type=script&lang=js"
export * from "./AdminCompaniesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-api/api.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('396e50c7')) {
      api.createRecord('396e50c7', component.options)
    } else {
      api.reload('396e50c7', component.options)
    }
    module.hot.accept("./AdminCompaniesTable.vue?vue&type=template&id=396e50c7", function () {
      api.rerender('396e50c7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/AdminCompaniesTable.vue"
export default component.exports